module.exports = __webpack_public_path__ + "img/contact_success_icon.671ffcc7.png";